import { message } from 'antd';
import { config } from 'util/config';
import { httpClient, uploadClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

//点击修改密码按钮
export function changePassword({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ showModalChangePassword: true, clientUserId: parameter.ClientUserId });
}

//修改密码提交表单
export function submitChangePassword({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ changePasswordFormSubmitting: true });
  var form = pageComponent.formRef.current?.getFieldsValue();
  form.ClientId = pageComponent.state.searchParameter.clientId;
  console.log(form);
  httpClient
    .post('Admin/ClientUser/ChangePassword/' + pageComponent.state.clientUserId, form)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ showModalChangePassword: false, changePasswordFormSubmitting: false });
        message.success('Reset password successful');
      } else {
        globalFunction.handleResultError(data, pageComponent);
        pageComponent.setState({ changePasswordFormSubmitting: false });
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
      pageComponent.setState({ changePasswordFormSubmitting: false });
    });
}

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create', isFormModified: false });

  setTimeout(() => {
    sectionComponent.customForm.current?.formRef.current?.resetFields();
    let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
    sectionComponent.props.section.componentList.filter(c => c.type === 'Create')[0].groupList.forEach(group => {
      group.uieList.forEach(uie => {
        switch (uie.component) {
          case 'Select':
            let option = {};
            if (uie.component === 'Select' && uie.type !== 'multiple') {
              if (componentDataSource[uie.source] !== undefined) {
                if (uie.type === 'group') {
                  componentDataSource[uie.source].some(group => {
                    if (group.SelectOptionList === null) {
                      option = group;
                      return true;
                    }
                    return group.SelectOptionList.some(selectOption => {
                      option = selectOption;
                      return true;
                    });
                  });
                } else {
                  option = componentDataSource[uie.source][0];
                }
              }
              if (componentDataSource[uie.source] !== undefined) {
                sectionComponent.customForm.current?.formRef.current?.setFieldValue(uie.source, option.Value);
              }
            }
            break;
        }
      });
    });

    // setTimeout(() => {
    //   sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ signaturePreview: null, fileList: [] });
    // }, config.setTimeoutMilliSecond * 5);
  }, config.setTimeoutMilliSecond);
}

//点击编辑时
export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ dataLoading: true });
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });

  setTimeout(() => {
    sectionComponent.customForm.current?.setState({ autoLoadComponentDataSource: false });
    sectionComponent.customForm.current?.getComponentDataSource();
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });
          //处理不适合antd组件的数据
          let componentDataSource = sectionComponent.customForm.current?.state.componentDataSource;
          sectionComponent.props.section.componentList.filter(c => c.type === 'Edit')[0].groupList.forEach(group => {
            group.uieList.forEach(uie => {
              switch (uie.component) {
                case 'Select':
                  //处理Select默认选项, 如果字段的值是null且备选项列表已加载, 则自动选择备选项里第一个(如果已有数据, 则加载备选项里有的那一条)
                  if ((data.data[uie.source] === null || data.data[uie.source] === undefined) && componentDataSource[uie.source] !== undefined) {
                    if (uie.type === null || uie.type.indexOf('multiple') < 0) {
                      data.data[uie.source] = componentDataSource[uie.source][0]?.Value;
                    }
                    if (uie.type !== null && uie.type.indexOf('multiple') >= 0) {
                      data.data[uie.source] = [];
                    }
                  }
                  break;
                case 'Input':
                  //处理Input, 如果type是fileName, 处理成改文件名的状态
                  if (uie.type === 'fileName') {
                    uie.addonAfter = globalFunction.getExtension(data.data[uie.source]);
                    data.data[uie.source] = globalFunction.getFileNameWithoutExtension(data.data[uie.source]);
                  }
                  break;
              }
            });
          });
          //把处理后的数据赋值给表单
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });
          sectionComponent.setState({ dataLoading: false });
          sectionComponent.setState({ isFormModified: false });

          let fileList = [];
          if (data.data.Signature !== null) {
            // 把原始的signature放入文件数组，这样重新提交时也能保存回去
            let binaryString = window.atob(data.data.Signature);
            let binaryLen = binaryString.length;
            let bytes = new Uint8Array(binaryLen);
            for (let i = 0; i < binaryLen; i++) {
              let ascii = binaryString.charCodeAt(i);
              bytes[i] = ascii;
            }

            let blob = new Blob([bytes], { type: 'application/octet-stream' });
            let file = new File([blob], 'signature.png', { type: 'application/octet-stream', lastModified: Date.now() });
            fileList.push(file);
          }
          if (sectionComponent.customForm.current?.additionalFormRef.current !== null) {
            sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ signaturePreview: data.data.Signature, fileList });
          }
        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

//特殊处理一些提交的条件
export function customFormOnSubmit({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let formData = new FormData();
  formData.append('ClientId', sectionComponent.props.clientId);
  let values = sectionComponent.customForm.current?.formRef.current?.getFieldsValue();
  for (let key in values) {
    if (values[key] !== undefined && values[key] !== null) {
      if (key !== 'ClientRoleIdList' && key !== 'file') {
        formData.append(key, values[key]);
      }
    }
  }

  var i = 0;
  if (values.ClientRoleIdList !== undefined) {
    values.ClientRoleIdList.map(element => {
      formData.append('ClientRoleIdList[' + i + ']', element);
      i++;
    });
  }

  if (sectionComponent.customForm.current?.additionalFormRef.current !== null) {
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.fileList.map((file) => {
      formData.append('files[]', file);
    })
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ signaturePreview: null });
  }

  sectionComponent.setState({ submitting: true });

  switch (sectionComponent.state.componentType) {
    case 'Create':
      uploadClient
        .post('Admin/ClientUser', formData)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ showModal: false, submitting: false });
            sectionComponent.getSectionDataByDefault();
          } else {
            globalFunction.handleResultError(data, pageComponent);
            sectionComponent.setState({ submitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ submitting: false });
        });
      break;
    case 'Edit':
      formData.append('key', sectionComponent.customForm.current?.state.currentDataKey);
      uploadClient
        .put('Admin/ClientUser', formData)
        .then(({ data }) => {
          if (data.result) {
            sectionComponent.setState({ showModal: false, submitting: false });
            sectionComponent.getSectionDataByDefault();
          } else {
            globalFunction.handleResultError(data, pageComponent);
            sectionComponent.setState({ submitting: false });
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
          sectionComponent.setState({ submitting: false });
        });
      break;
  }
}
